import React, { useState, useCallback, useContext } from 'react';
import { GameContext } from '../context/GameContext';
import '../styles/Limit.css';
import '@fortawesome/fontawesome-free/css/all.min.css'; 

export const Limit = () => {
  const { setLimit, limitLabel } = useContext(GameContext);
  const [dropdownVisible, setDropdownVisible] = useState(false);

  const toggleDropdown = useCallback(() => {
    setDropdownVisible(!dropdownVisible);
  }, [dropdownVisible]);

  const selectLimit = useCallback((limit) => {
    setLimit(limit);
    toggleDropdown();
  }, [setLimit, toggleDropdown]);

  const limitOptions = [
    { label: 'Direct 2', limit: [1, 2] },
    { label: 'Direct 3', limit: [1, 3] },
    { label: 'PERM 2', limit: [3, 24] },
    { label: 'PERM 3', limit: [4, 17] },
    { label: 'PERM 4', limit: [5, 13] },
    { label: 'PERM 5', limit: [6, 12] },
    { label: 'Banker Against All', limit: [1, 1] },
  ];

  return (
    <div>
      <button className="dropdown-button1" id="number-selection"onClick={toggleDropdown}>
        GAME TYPE: <span style={{ color: "#0a324d", fontSize: "16px",  }}>{limitLabel}</span>
                <i style={{  color: "#0a324d", fontSize: "16px" }} className={`fas fa-chevron-${dropdownVisible ? 'up' : 'down'}`}></i>
      </button>
      {dropdownVisible && (
        <div className="dropdown-overlay" onClick={toggleDropdown}>
          <div className="dropdown-container" onClick={e => e.stopPropagation()}>
            {limitOptions.map((item) => (
              <div key={item.label} className="dropdown-item" onClick={() => selectLimit(item.limit)}>
                {item.label}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};
